/**
 * JWT Payload 型定義
 */
export interface JwtPayload {
  exp?: number;
  iat?: number;
  user_id?: string;
  [key: string]: unknown;
}

/**
 * JWT トークンをデコード（Base64URL）
 *
 * Entities層の責務:
 * - JWTトークンの解析（ドメインロジック）
 * - 型安全なpayloadの返却
 */
export function decodeJwt(token: string | null | undefined): JwtPayload | null {
  if (!token) return null;

  const parts = token.split('.');
  if (parts.length !== 3 || !parts[1]) return null;

  try {
    // Base64URL デコード
    const base64 = parts[1].replace(/-/g, '+').replace(/_/g, '/');
    const json = atob(base64);
    return JSON.parse(json);
  } catch {
    return null;
  }
}

/**
 * トークンの有効期限までの残り時間（ミリ秒）を取得
 */
export function msUntilExpiry(token?: string | null): number | null {
  const payload = decodeJwt(token);
  if (!payload?.exp) return null;

  const expMs = payload.exp * 1000;
  return Math.max(0, expMs - Date.now());
}

/**
 * トークンが有効かチェック
 */
export function isTokenValid(token?: string | null): boolean {
  if (!token) return false;

  const ms = msUntilExpiry(token);
  return ms !== null && ms > 0;
}
